import { render, staticRenderFns } from "./sim-out-test.vue?vue&type=template&id=514227c0"
import script from "./sim-out-test.vue?vue&type=script&lang=ts"
export * from "./sim-out-test.vue?vue&type=script&lang=ts"
import style0 from "./sim-out-test.vue?vue&type=style&index=0&id=514227c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports